(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cashback-calculator"] && !Shopify.designMode) return;
  try {
    
  const range = document.querySelector('.spend_range');
  const value = document.querySelector('.spend');
  const cashback = document.querySelector('.cashback');

  range.addEventListener('input', () => {
    value.textContent = '$' + Number(range.value).toLocaleString();
    cashback.textContent = (Number(range.value) * 0.05).toLocaleString('en-AU', {
      style: 'currency',
      currency: 'AUD',
    });
  });

  } catch(e) { console.error(e); }
})();
})();
